import createAxios from "./axiosHttp";

function getDecas(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/deca/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function preloadDeca(stopId) {
  const axios = createAxios();
  const urlPath = `ttmm/deca/${stopId}/preload`;
  return axios.get(urlPath);
}

function generateDeca(stopId, payload) {
  const axios = createAxios();
  const urlPath = `ttmm/deca/${stopId}`;
  return axios.put(urlPath, payload);
}

function printDeca(stopIds) {
  const axios = createAxios();
  const urlPath = "ttmm/deca/print";
  return axios.put(
    urlPath,
    { stop_ids: stopIds },
    { responseType: "arraybuffer" }
  );
}

export const decaService = {
  getDecas,
  preloadDeca,
  generateDeca,
  printDeca,
};
